import React, { useState } from "react";
import { FaCloudUploadAlt } from "react-icons/fa";
import { MdOutlineAnalytics } from "react-icons/md";
import { IoMdRefresh } from "react-icons/io";
import Navbar from "./Navbar";
import axios from "axios";
import {API_URL,FAST_API_URL} from "../api"

const ImageAnalysis = () => {
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [analysisResult, setAnalysisResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const [session, setsession] = useState({});

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 0) {
      setSelectedFiles(files);
      setSelectedImages(files.map((file) => URL.createObjectURL(file)));
      setAnalysisResult(null);
    }
  };

  const handleAnalyze = async () => {
    setLoading(true);
    const formData = new FormData();
    selectedFiles.forEach((file) => {
      formData.append("files", file);
    });
    formData.append("session", JSON.stringify(session));
    formData.append("phone_number", localStorage.getItem("patient_phone_number"));

    try {
      const response = await axios.post(
        `${FAST_API_URL}/api/x_ray_analyze`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const result = response.data?.analysis || "No result returned from API.";

      setAnalysisResult(null);

      setTimeout(() => {
        setAnalysisResult(result);
        setsession(response.data.session_received);
        setLoading(false);
      }, 2000);
    } catch (error) {
      setAnalysisResult(`❌ Error: ${error?.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setSelectedFiles([]);
    setSelectedImages([]);
    setAnalysisResult(null);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-slate-200 p-4">
      <Navbar />

      {analysisResult ? (
        // Full Page Result View
        <div className="max-w-5xl mx-auto mt-10 bg-white border-l-4 border-green-500 p-8 rounded-2xl shadow text-gray-800 whitespace-pre-line text-base leading-relaxed font-medium min-h-[70vh] relative">
          <button
            onClick={() => setAnalysisResult(null)}
            className="absolute top-4 right-4 bg-blue-100 text-blue-800 px-4 py-1 rounded-full shadow hover:bg-blue-200"
          >
            ⬅ Back
          </button>
          <h2 className="text-2xl font-bold text-green-700 mb-6">📝 Analysis Result</h2>
          <div className="overflow-y-auto max-h-[70vh] pr-4">
            {Array.isArray(analysisResult)
              ? analysisResult.map((item, index) => (
                  <div key={index} className="mb-4">
                    <h3 className="font-semibold text-blue-700 mb-1">
                      📎 {item.filename}
                    </h3>
                    <pre className="whitespace-pre-wrap bg-gray-100 p-2 rounded">
                      {item.analysis}
                    </pre>
                  </div>
                ))
              : analysisResult}
          </div>
        </div>
      ) : (
        // Upload & Analyze UI
        <div className="max-w-3xl mx-auto mt-6 space-y-6">
          <h1 className="text-2xl font-extrabold text-center text-blue-800 drop-shadow-sm">
            🩻 Medical Image Analysis
          </h1>

          <div className="bg-white/80 backdrop-blur-md rounded-2xl border border-slate-300 shadow-lg p-6 space-y-6 transition-all duration-300">
            {selectedImages.length === 0 ? (
              <div className="flex flex-col items-center space-y-4">
                <label
                  htmlFor="image-upload"
                  className="cursor-pointer px-6 py-3 rounded-lg text-md font-semibold text-white bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 shadow-md flex items-center gap-2"
                >
                  <FaCloudUploadAlt size={20} />
                  Upload Images
                </label>
                <input
                  type="file"
                  id="image-upload"
                  accept="image/*"
                  multiple
                  onChange={handleImageChange}
                  className="hidden"
                />
              </div>
            ) : (
              <div className="flex flex-col items-center gap-6">
                <div className="flex flex-wrap justify-center gap-4">
                  {selectedImages.map((image, index) => (
                    <div
                      key={index}
                      className="relative w-[120px] h-[120px] border border-blue-300 rounded-lg shadow-md overflow-hidden"
                    >
                      <img
                        src={image}
                        alt={`Preview ${index + 1}`}
                        className="w-full h-full object-cover"
                      />
                    </div>
                  ))}
                  <button
                    onClick={handleReset}
                    className="absolute top-2 right-2 bg-white text-blue-600 hover:bg-blue-100 p-1 rounded-full shadow"
                    title="Reset"
                  >
                    <IoMdRefresh size={20} />
                  </button>
                </div>

                <button
                  onClick={handleAnalyze}
                  disabled={loading}
                  className={`flex items-center justify-center gap-2 px-4 py-3 text-md font-medium rounded-lg text-white transition-all duration-300 shadow-md ${
                    loading
                      ? "bg-gray-400 cursor-wait"
                      : "bg-gradient-to-r from-green-600 to-emerald-500 hover:from-green-700 hover:to-emerald-600 hover:shadow-lg"
                  }`}
                >
                  <MdOutlineAnalytics size={20} />
                  {loading ? "Analyzing..." : "Run Analysis"}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageAnalysis;
